import React, { useContext } from 'react';
import { FirebaseContext } from '.';
import { useHistory } from 'react-router-dom';
import { v4 } from 'uuid';

const NewReadlist = () => {
  const history = useHistory();
  const { auth, firestore, analytics } = useContext(FirebaseContext);
  const readlistsCollection = firestore.collection('readlists');

  const createNewReadlist = async (): Promise<void> => {
    if (auth.currentUser) {
      const { uid } = auth.currentUser;

      try {
        const readlistRef = await readlistsCollection.add({
          name: 'Readlist ' + v4().toString(),
          owner: uid,
          collaborators: [],
        });
        const readlist = await readlistRef.get();
        history.push('/readlist/' + readlist.id);
      } catch(error) {
        console.log('Error: ', error);
        analytics.logEvent('exception', { description: 'Adding new readlist failed', fatal: false, error });
      }
    }
  };
  
  return (
    <div className='col d-flex justify-content-center my-5'>
      <button className='btn btn-primary col-md-5 col' onClick={ createNewReadlist } >Create new readlist</button>
    </div>
  );
};

export default NewReadlist;